// Smart Sash Admin Panel - Certification Models
// User certification and testing related types

import { InstitutionEntity } from './common.models';

/**
 * Certification entity (full model)
 */
export interface Certification extends InstitutionEntity {
  userId: string;
  certificationDate: string;
  score?: number | null;
  passed: boolean;
  expiresAt?: string | null;
  certificationData?: string | null;
}

/**
 * Certification DTO (prevents circular references)
 */
export interface CertificationDTO {
  id: string;
  institutionId: string;
  userId: string;
  certificationDate: string;
  score?: number | null;
  passed: boolean;
  expiresAt?: string | null;
  certificationData?: string | null;
}

/**
 * Certification question entity
 */
export interface CertificationQuestion extends InstitutionEntity {
  question?: string | null;
  questionType?: string | null;
  answersJson?: string | null;
  correctAnswer?: string | null;
  points: number;
  isActive: boolean;
}

/**
 * Question type enum
 */
export enum QuestionType {
  MultipleChoice = 'MultipleChoice',
  TrueFalse = 'TrueFalse',
  ShortAnswer = 'ShortAnswer',
  Essay = 'Essay',
}

/**
 * Certification question with parsed answers
 */
export interface CertificationQuestionParsed extends Omit<CertificationQuestion, 'answersJson'> {
  answers: CertificationAnswer[];
}

/**
 * Certification answer option
 */
export interface CertificationAnswer {
  id: string;
  text: string;
  isCorrect: boolean;
}

/**
 * Request payload for creating a new certification question
 */
export interface CreateCertificationQuestionRequest {
  institutionId: string;
  question: string;
  questionType: string;
  answersJson: string;
  correctAnswer: string;
  points: number;
  isActive: boolean;
}

/**
 * Request payload for updating an existing certification question
 */
export interface UpdateCertificationQuestionRequest {
  question?: string;
  questionType?: string;
  answersJson?: string;
  correctAnswer?: string;
  points?: number;
  isActive?: boolean;
}

/**
 * Certification configuration
 */
export interface CertificationConfiguration {
  passingScore: number; // Percentage (0-100)
  validityPeriod?: number; // Days until expiration
  maxAttempts?: number;
  shuffleQuestions: boolean;
  showCorrectAnswers: boolean;
  allowRetake: boolean;
}
